module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/app.component.html
// module id = ./src/app/core/components/app.component.html
// module chunks = main